import React, { useEffect, useState } from 'react'

import Topbar from './Topbar'
import Sidebar_component from './Sidebar_component'

import total_hour from '../images/totalhours.png'
import today_hour from "../images/todaywork.png"
import completed from "../images/completed.png"
import pending from "../images/pending.png"
import activetask from "../images/activetask.png"

export default function My_worklog() {

    const [monthHours, setMonthHours] = useState('0h 0m');
    const [todayHours, setTodayHours] = useState('0h 0m');
    const [pendingTask, setPendingTask] = useState(0);
    const [activeTask, setActiveTask] = useState(0);
    const [completeTask, setCompleteTask] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [pendingTaskList, setPendingTaskList] = useState([]);
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const memberid = localStorage.getItem('member_id');
        loadPersonalWorklog(memberid);
    }, []);

    // =====================================
    // LOAD WORKLOG
    // =====================================

    async function loadPersonalWorklog(memid) {

        try {

            const response = await fetch(
                'getPersonalWorklog.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        member_id: memid
                    })
                }
            );

            const data = await response.json();
            setMonthHours(data.month_hours);
            setTodayHours(data.today_hours);
            setPendingTask(data.pending_task);
            setActiveTask(data.active_task);
            setCompleteTask(data.complete_task);
        } catch (error) {
            console.log(error);
        }

    }

    async function showpendingtasklist() {

        try {
            const memberid =
                localStorage.getItem('member_id');
            const response = await fetch(
                'getMemberPendingTask.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        member_id: memberid
                    })
                }
            );
            const data = await response.json();
            setPendingTaskList(data);
            setShowPopup(true);
        } catch (error) {
            console.log(error);
        }
    }

    function closePopup() {
        setShowPopup(false);
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>
                        Work Log
                    </h2>
                    <p className='fullwidth pull_left pb-30'>
                        Track daily work updates,
                        time spent,
                        and task progress.
                    </p>
                </div>
                <div className='fullwidth'>
                    <div className='vl_listing_row'>
                        {/* TOTAL MONTH */}
                        <div className='vl_dsh_one_third'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={total_hour} alt="Total hour" />
                                </div>
                                <h3>Total Logged Hours</h3>
                                <span>Total hours worked this month
                                </span>
                                <p>{monthHours}</p>
                            </div>
                        </div>
                        {/* TODAY */}
                        <div className='vl_dsh_one_third'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={today_hour} alt="Today" />
                                </div>
                                <h3>Today's Work</h3>
                                <span> Total hours worked today</span>
                                <p>{todayHours} </p>
                            </div>
                        </div>
                        {/* COMPLETE */}
                        <div className='vl_dsh_one_third'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={completed} alt="Completed" />
                                </div>
                                <h3>  Completed Tasks </h3>
                                <span> Task completed </span>
                                <p>{completeTask}</p>
                            </div>
                        </div>
                    </div>
                    <div className='vl_listing_row'>
                        {/* PENDING */}
                        <div className='vl_dsh_one_third'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={pending} alt="Pending" />
                                </div>
                                <h3>Pending Tasks</h3>
                                <span>Total pending tasks: </span>
                                <span>{pendingTask}</span>
                                <div className='small_buttonholder'>
                                    <button onClick={showpendingtasklist}>View</button>
                                </div>
                            </div>
                        </div>
                        {/* ACTIVE */}
                        <div className='vl_dsh_one_third'>
                            <div className='resource_inner'>
                                <div className='card_imgholder'>
                                    <img src={activetask} alt="Active" />
                                </div>
                                <h3>Active Tasks</h3>
                                <span>Active tasks</span>
                                <p>{activeTask}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showPopup && (
                    <div className='vl_popup_overlay'>
                        <div className='vl_popup_box'>
                            <div className='vl_popup_header'>
                                <h2>Pending Task List</h2>
                                <button
                                    className='vl_close_btn'
                                    onClick={closePopup}
                                >
                                    ×
                                </button>
                            </div>
                            <div className='vl_popup_body'>
                                {
                                    pendingTaskList.length > 0 ? (
                                        <table className='vl_task_table'>
                                            <thead>
                                                <tr>
                                                    <th>Task Name</th>
                                                    <th>Status</th>
                                                    <th>Task details</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pendingTaskList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.task_name}</td>
                                                            <td>{item.task_status}</td>
                                                            <td>{item.task_desc}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className='vl_empty_state'>
                                            No pending task found
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            }
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}